<div class="form-modal">
    <mat-dialog-content>
        <a tabindex="0" (click)="onClose()" (keypress)="onClose()" class="close-modal"
            aria-label="Close organization edit form">
            <img src="./assets/img/icons-svg/close-icon.svg" />
        </a>
        <div class="img-wrapper">
            <div class="clearfix"></div>
            <div class="title-wrapper">
                <h1>{{ title }}</h1>
            </div>
        </div>

        <popup-loader *ngIf="!isLoaded"></popup-loader>
        <form novalidate [formGroup]="courseEditForm" (ngSubmit)="doSave()">
            <div id="resource-section" class="form-wrapper-80" *ngIf="isLoaded">

                <mat-form-field class="wt-mat-form-field">
                    <input matInput formControlName="groupname" class="wt-mat-input" placeholder="Group Name"
                        type="text" />
                    <mat-error *ngIf="f.groupname.touched && f.groupname.errors?.required">
                        Group name is required
                    </mat-error>
                </mat-form-field>



                <mat-accordion cdkDropList (cdkDropListDropped)="drop($event)" formArrayName="dailydata">
                    <mat-expansion-panel class="groupset" *ngFor="
					let chapter of dailydata.controls;
						let i = index
					" cdkDrag (opened)="panelOpenState = true" (closed)="panelOpenState = false" [formGroupName]="i">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Daily Content {{ i + 1 }}</mat-panel-title>
                            <mat-panel-description *ngIf="dailydata.length > 1">
                                <a class="removeGroup" tabindex="0" (click)="onRemoveDailyContentItem(i)"
                                    (keypress)="onRemoveDailyContentItem(i)"><img
                                        src="./assets/img/icons-svg/x-icon.svg" /></a>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <ng-container padding>
                            <mat-form-field class="wt-mat-form-field">
                                <mat-label for="category" translate>Course Category</mat-label>
                                <mat-select formControlName="category">
                                    <mat-option *ngFor="let category of categoryList" [value]="category.ID">
                                        {{ category.Title }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field  appearance="outline" class="wt-mat-form-field">
                                <textarea matInput placeholder="Daily Boost - English" formControlName="quotesen"></textarea>
                                <mat-error *ngIf="
										getDailyAddFormGroup(i).controls['quotesen'].touched &&
										getDailyAddFormGroup(i).controls['quotesen'].errors?.required
									">
                                    Daily Boost - English is required
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field  appearance="outline" class="wt-mat-form-field">
                                <textarea matInput placeholder="Daily Boost - French" formControlName="quotesfr"></textarea>
                                <mat-error *ngIf="
										getDailyAddFormGroup(i).controls['quotesfr'].touched &&
										getDailyAddFormGroup(i).controls['quotesfr'].errors?.required
									">
                                    Daily Boost - French is required
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field  appearance="outline" class="wt-mat-form-field">
                                <textarea matInput placeholder="Daily Boost - Spanish" formControlName="quoteses"></textarea>
                                    <mat-error *ngIf="
										getDailyAddFormGroup(i).controls['quoteses'].touched &&
										getDailyAddFormGroup(i).controls['quoteses'].errors?.required
									">
                                    Daily Boost - Spanish is required
                                </mat-error>
                            </mat-form-field>
                        </ng-container>
                    </mat-expansion-panel>
                </mat-accordion>
                <a tabindex="0" class="btn-primary btn-inline btn" (click)="addDailyContentItem({})"
                    (keypress)="addDailyContentItem({})">Add Daily Content</a>
                <div class="fixed-footer">
                    <p class="red" *ngIf="submitButtonPressed && !courseEditForm.valid && errors === ''">Please check
                        the errors</p>
                    <p class="red">{{errors}}</p>
                    <!-- <button
						tabindex="0"
						class="btn-primary btn"
					>
						Save
					</button> -->
                    <a tabindex="0" class="btn-primary btn-bold btn" (click)="doSave()" (keypress)="doSave()">Save</a>
                </div>
            </div>
        </form>
    </mat-dialog-content>
</div>